import * as AuthActions from '../actions/auth'

export interface State {
  authorized: boolean
}

const initialState: State = {
  authorized: null
}

export function reducer(state: State = initialState, action: AuthActions.All): State {
  switch (action.type) {
    case AuthActions.AUTHORIZED: {
      return {
        ...state,
        authorized: true,
      }
    }
    case AuthActions.UNAUTHORIZED: {
      return {
        ...state,
        authorized: false,
      }
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.ts